import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProductContents } from './components/ProductContents';
import { EliteEbooks } from './components/EliteEbooks';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { CheckoutSection } from './components/CheckoutSection';
import { FooterSection } from './components/FooterSection';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-light font-sans text-dark selection:bg-gold-200 selection:text-dark overflow-x-hidden" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <ProductContents data-id="element-5" />
        <EliteEbooks data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <FAQSection data-id="element-8" />
        <CheckoutSection data-id="element-9" />
      </main>
      <FooterSection data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}